import { useEffect } from 'react'
import {
  CookieKeyTypeEnum,
  getCookieItem,
  removeCookieItem,
  setCookieItem,
} from 'src/util/cookie-domain'
import { useGlobalContext } from '../contextoGlobal'

const useZipcode = () => {
  const { zipcode, setZipcode } = useGlobalContext()

  useEffect(() => {
    setZipcode(getCookieItem(CookieKeyTypeEnum.cep) ?? '')
  }, [setZipcode])

  const set = (zipcode: string) => {
    setZipcode(zipcode)
    setCookieItem(CookieKeyTypeEnum.cep, zipcode)
  }

  const remove = () => {
    setZipcode(undefined)
    removeCookieItem(CookieKeyTypeEnum.cep)
  }

  return {
    zipcode,
    set,
    remove,
  }
}

export default useZipcode
